export const MOVE_PROJECTS_FOLDER = 'MOVE_PROJECTS_FOLDER'
